import React from 'react';
import PropTypes from 'prop-types';
import { GeometryUtils } from '../../utils/export';
import Ruler from './ruler';
import If from '../../utils/react-if';
import * as SharedStyle from '../../shared-style';

var STYLE_TEXT = {
  textAnchor: "middle",
  fontSize: "12px",
  fontFamily: "'Courier New', Courier, monospace",
  pointerEvents: "none",
  fontWeight: "bold",

  //http://stackoverflow.com/questions/826782/how-to-disable-text-selection-highlighting-using-css
  WebkitTouchCallout: "none", /* iOS Safari */
  WebkitUserSelect: "none", /* Chrome/Safari/Opera */
  MozUserSelect: "none", /* Firefox */
  MsUserSelect: "none", /* Internet Explorer/Edge */
  userSelect: "none"
};

export default function Line(_ref) {
  var line = _ref.line,
      layer = _ref.layer,
      scene = _ref.scene,
      catalog = _ref.catalog,
      isDesktop = _ref.isDesktop;


  var vertex0 = layer.vertices.get(line.vertices.get(0));
  var vertex1 = layer.vertices.get(line.vertices.get(1));

  if (vertex0.id === vertex1.id || GeometryUtils.samePoints(vertex0, vertex1)) return null; //avoid 0-length lines

  var x1 = vertex0.x,
      y1 = vertex0.y;
  var x2 = vertex1.x,
      y2 = vertex1.y;


  if (x1 > x2) {
    x1 = vertex1.x;
    y1 = vertex1.y;
    x2 = vertex0.x;
    y2 = vertex0.y;
  }

  var length = GeometryUtils.pointsDistance(x1, y1, x2, y2);
  var angle = GeometryUtils.angleBetweenTwoPointsAndOrigin(x1, y1, x2, y2);
  var removePoint = 49;
  var renderedHoles = line.holes.map(function (holeID) {
    var hole = layer.holes.get(holeID);
    var startAt = length * hole.offset;
    var renderedHole = catalog.getElement(hole.type).render2D(hole, layer, scene);
    return React.createElement(
      'g',
      {
        key: holeID,
        transform: 'translate(' + startAt + ', 0)',
        'data-element-root': true,
        'data-prototype': hole.prototype,
        'data-id': hole.id,
        'data-selected': hole.selected,
        'data-layer': layer.id
      },
      renderedHole,
      React.createElement(
        If,
        { condition: hole.selected && hole.properties.get('width') !== undefined && hole.getIn(['properties', 'width', 'length']) >= removePoint },
        React.createElement(
          'g',
          { 'data-element-root': true,
            'data-prototype': hole.prototype,
            'data-id': hole.id,
            'data-selected': hole.selected,
            'data-layer': layer.id,
            'data-part': 'resize-anchor-width'
          },
          React.createElement('circle', { cx: hole.getIn(['properties', 'width', 'length']) / 2, cy: '0',
            r: isDesktop ? SharedStyle.CONTROL_POINT_RADIUS : SharedStyle.CONTROL_POINT_RADIUS_BIG, style: SharedStyle.CONTROL_POINT_STYLE }),
          React.createElement(
            'g',
            { transform: 'translate(' + (hole.getIn(['properties', 'width', 'length']) / 2 - (isDesktop ? 6 : 12)) + ' ' + (isDesktop ? -5 : -10) + ')\n            ' + (isDesktop ? 'scale(1, 1)' : 'scale(2, 2)') },
            React.createElement('polyline', { points: '1,5 4,8 4,2 1,5', style: SharedStyle.CONTROL_POINT_ARROW_STYLE }),
            React.createElement('polyline', { points: '1,5 4,8 4,2 1,5', transform: 'translate(12,0) rotate(180,0,5)', style: SharedStyle.CONTROL_POINT_ARROW_STYLE })
          )
        )
      )
    );
  });

  var thickness = line.getIn(['properties', 'thickness', 'length']);
  var half_thickness = thickness / 2;

  var renderedLine = catalog.getElement(line.type).render2D(line, layer);
  var distanceText = length.toFixed(2) + ' ' + scene.unit;
  var renderedRuler = line.selected ? React.createElement(Ruler, { unit: scene.unit, length: length, transform: 'translate(0, ' + (half_thickness + 10) + ' )' }) : React.createElement(
    'text',
    { x: length / 2, y: '-20', transform: 'scale(1, -1)', style: STYLE_TEXT },
    distanceText
  );

  return React.createElement(
    'g',
    {
      transform: 'translate(' + x1 + ', ' + y1 + ') rotate(' + angle + ', 0, 0)',
      'data-element-root': true,
      'data-prototype': line.prototype,
      'data-id': line.id,
      'data-selected': line.selected,
      'data-layer': layer.id,
      style: line.selected ? { cursor: 'move' } : {}
    },
    renderedRuler,
    renderedLine,
    renderedHoles
  );
}

Line.propTypes = {
  line: PropTypes.object.isRequired,
  layer: PropTypes.object.isRequired,
  scene: PropTypes.object.isRequired,
  catalog: PropTypes.object.isRequired,
  isDesktop: PropTypes.bool.isRequired
};